var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 376,
    height: 153.75,
    viewBox: "0 0 376 153.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(-20.465 -92.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11651",
    "data-name": "Rectangle 11651",
    width: 376,
    height: 115,
    rx: 5,
    transform: "translate(20.465 131)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53610",
    "data-name": "Path 53610",
    d: "M182.687,99.376,158.768,87.416A3.986,3.986,0,0,0,153,90.984V114.9a3.989,3.989,0,0,0,5.768,3.568l23.919-11.959a3.989,3.989,0,0,0,0-7.136Z",
    transform: "translate(36.977 85.994)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53678",
    "data-name": "Path 53678",
    d: "M0,0H178",
    transform: "translate(116.965 94.75)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_408",
    "data-name": "Line 408",
    x2: 95,
    transform: "translate(157.965 112.468)",
    fill: "none",
    stroke: "#bdc7cf",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.eca26b4a8fe0b9e2567499189c4dd46f.svg";
export { ForwardRef as ReactComponent };